export default __webpack_public_path__ + "static/media/Main_Roadmap_Img_3_440px.dd0b979a.png";